import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from '@firebase/app';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'page-admin',
  templateUrl: 'admin.html',
})
export class AdminPage {

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
  ) {
    this.userService = new UserService();
    if (this.router.url.includes('huntersterlingalexcsv')) {
      this.getCSVofUsers();
    }
  }

  async getCSVofUsers() {
    let rows = await this.userService.updateMailChimp();
    console.log(rows);
    setTimeout(() => {this.downloadCSV({ filename: "ReadyForMailchimp.csv"}, rows )}, 4000);
  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
            if (ctr > 0) result += columnDelimiter;

            result += item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
  }

  downloadCSV(args, users) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
        data: users
    });
    if (csv == null) return;

    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
}

}



// WEBPACK FOOTER //
// ./src/pages/admin/admin.ts